import React, { Component, Fragment } from 'react'
import { Form } from 'informed'

import { DataTable } from 'components//DataTable/'
import { TableSearch } from 'components//DataTable/components'
import Button from 'components/Button'
import { Checkbox } from 'components/forms'
import Divider from 'components/Divider'

class ProductList extends Component {
	getTrProps = (state, rowInfo, formApi) => {
		return {
			onClick: (e) => {
				e.preventDefault()
				const id = rowInfo.original.id,
					checked = formApi.values[id],
					allValues = formApi.values

				formApi.setValue(id, !checked)
				if(checked) {
					formApi.setValue('allChecked', false)
				} else {
					// Check 'All' checkbox if all others (except itself and 'All' checkbox) is checked
					const restChecked = Object.keys(allValues).filter(key => key !== `${id}` && key !== 'allChecked').every(key => allValues[key])
					formApi.setValue('allChecked', restChecked)
				}
			},
			className: formApi.values[rowInfo.original.id] ? 'tr-checked' : ''
		}
	}

	handleRowClick = (rowInfo, { formApi, formState }) => {
		const id = rowInfo.original.id,
			checked = formState.values[id],
			allValues = formState.values

		formApi.setValue(id, !checked)
		if(checked) {
			formApi.setValue('allChecked', false)
		} else {
			// Check 'All' checkbox if all others (except itself and 'All' checkbox) is checked
			const restChecked = Object.keys(allValues).filter(key => key !== `${id}` && key !== 'allChecked').every(key => allValues[key])
			formApi.setValue('allChecked', restChecked)
		}
	}

	handleChangeAll = (e, { formApi, formState }) => {
		let allValues = { ...formState.values }
		Object.keys(allValues).forEach(key => {
			allValues[key] = e
		})

		formApi.setValues(allValues)
	}

	onSubmit = vals => {
		delete vals.allChecked
		this.props.onSubmit(vals)
		this.props.closeModal()
	}

	render({ tableData: { data, columns }, defaultChecked, onSubmit } = this.props) {
		const colsWithCheckBoxes = columns.map(col => col.accessor === 'number' ?
				{
					...col,
					Cell: props => (
						<Checkbox field={`${props.original.id}`} label={props.value} defaultValue={defaultChecked.indexOf(`${props.original.id}`) >= 0} />)
				} : col
			),
			headComponent = (formApi) => (
				<div>
					<TableSearch />
					<div className='container-thead-check'>
						<div className='rt-td'>
							<Checkbox field='allChecked' label='Alle' defaultValue={false} onChange={(e) => this.handleChangeAll(e, formApi)} />
						</div>
					</div>
				</div>
			)

		return(
			<div>
				<Form onSubmit={({ formState }) => this.onSubmit(formState.values)} render={({ formApi, formState }) => (
					<Fragment>
						<DataTable
							data={data}
							columns={colsWithCheckBoxes}
							onRowClick={(state, rowInfo) => this.handleRowClick(rowInfo, { formApi, formState })}
							noDefaultRowClick
							getTrProps={(state, rowInfo) => ({ className: formState.values[rowInfo.original.id] ? 'tr-checked' : '' })}
							TheadComponent={() => headComponent({ formApi, formState })}
							style={{ height: '668px' }} />
						<Divider />
						<Button text='Artikel hinzufügen' status='primary' />
					</Fragment>
				)}/>
			</div>
		)
	}
}

export default ProductList
